import { z } from 'zod';
import { Attribution, Cid, SessionKey, SiteId, TenantId, VisitorKey } from './common';

export const CtaMatchType = z.enum(['url', 'text']);

export const CtaEventRequest = z.object({
  tenant_id: TenantId,
  site_id: SiteId,
  landing_page_id: z.string().regex(/^lp_[a-zA-Z0-9_-]{1,61}$/),
  visitor_id: VisitorKey,
  session_id: SessionKey,
  cid: Cid.nullable().optional(),
  cta_id: z.string().min(1).max(128),
  cta_label: z.string().max(255).nullable().optional(),
  match_type: CtaMatchType,
  page_location: z.string().url().max(2048).optional(),
  referrer: z.string().max(2048).nullable().optional(),
  attribution: Attribution.optional(),
  occurred_at: z.string().datetime(),
});

export const CtaTargetPublic = z.object({
  cta_id: z.string().min(1).max(128),
  match_type: CtaMatchType,
  pattern: z.string().min(1).max(2048),
  label: z.string().max(255),
});

export const CtaTargetsPublicResponse = z.object({
  targets: z.array(CtaTargetPublic).max(100),
});

export type CtaEventRequest = z.infer<typeof CtaEventRequest>;
export type CtaTargetPublic = z.infer<typeof CtaTargetPublic>;
